var map = {
	"./CONTACT.png": 63838,
	"./WOD/01.png": 1002,
	"./aiCard/mobile/ai-driven.png": 76951,
	"./aiCard/mobile/app_store_text.png": 85341,
	"./aiCard/mobile/arrow_left.png": 71031,
	"./aiCard/mobile/arrow_right.png": 11438,
	"./aiCard/mobile/bg_img.png": 21899,
	"./aiCard/mobile/card_games.png": 33180,
	"./aiCard/mobile/game_img_bg.png": 2314,
	"./aiCard/mobile/game_img_bg_active.png": 97747,
	"./aiCard/mobile/game_title.png": 9511,
	"./aiCard/mobile/google_play_text.png": 71198,
	"./aiCard/mobile/log_content_bg.png": 58932,
	"./aiCard/mobile/log_title.png": 91527,
	"./aiCard/mobile/news_bg.png": 64971,
	"./aiCard/mobile/news_more_bg.png": 99197,
	"./aiCard/mobile/news_title.png": 56564,
	"./aiCard/mobile/page_num_bg.png": 90736,
	"./aiCard/mobile/strategy.png": 46429,
	"./aiCard/mobile/swiper_banner1.png": 41704,
	"./aiCard/mobile/swiper_banner2.png": 49231,
	"./aiCard/mobile/swiper_banner3.png": 20234,
	"./aiCard/mobile/swiper_banner4.png": 50193,
	"./aiCard/mobile/swiper_banner5.png": 19140,
	"./aiCard/pc/Frame 342@2x.png": 83777,
	"./aiCard/pc/ai-driven.png": 66942,
	"./aiCard/pc/app_store_text.png": 61210,
	"./aiCard/pc/arrow_left.png": 42932,
	"./aiCard/pc/arrow_right.png": 39043,
	"./aiCard/pc/banner_icon_bg.png": 8369,
	"./aiCard/pc/banner_icon_bg2.png": 39017,
	"./aiCard/pc/banner_icon_bg3.png": 97372,
	"./aiCard/pc/bg_img.png": 63660,
	"./aiCard/pc/card_games.png": 8375,
	"./aiCard/pc/game_img_bg.png": 81343,
	"./aiCard/pc/game_img_bg_active.png": 5968,
	"./aiCard/pc/game_title.png": 65792,
	"./aiCard/pc/google_play_text.png": 19389,
	"./aiCard/pc/icon1.png": 76583,
	"./aiCard/pc/icon2.png": 35712,
	"./aiCard/pc/icon3.png": 85677,
	"./aiCard/pc/log_content_bg.png": 4899,
	"./aiCard/pc/log_title.png": 6054,
	"./aiCard/pc/news_bg.png": 5702,
	"./aiCard/pc/news_title.png": 27415,
	"./aiCard/pc/page_num_bg.png": 94033,
	"./aiCard/pc/strategy.png": 44550,
	"./aiCard/pc/swiper_banner1.png": 78095,
	"./aiCard/pc/swiper_banner2.png": 18088,
	"./aiCard/pc/swiper_banner3.png": 59445,
	"./aiCard/pc/swiper_banner4.png": 10326,
	"./aiCard/pc/swiper_banner5.png": 41979,
	"./arrow_down.png": 37188,
	"./arrow_up.png": 9947,
	"./back.png": 76991,
	"./blog.png": 82606,
	"./blog_bg.png": 29716,
	"./btn1.png": 59887,
	"./btn2.png": 52360,
	"./close.png": 81598,
	"./come_on_bite_me/01.jpg": 7274,
	"./come_on_bite_me/02.jpg": 17945,
	"./come_on_bite_me/03.jpg": 11784,
	"./come_on_bite_me/04.jpg": 30756,
	"./come_on_bite_me/05.jpg": 32686,
	"./confirm.png": 88986,
	"./confirmbg.png": 28967,
	"./contack_eamil.png": 56648,
	"./contack_ins.png": 1396,
	"./contact_bd.png": 76827,
	"./contact_bg.png": 71044,
	"./contact_fb.png": 99785,
	"./contact_ig.png": 51937,
	"./contact_tt.png": 3333,
	"./contact_tw.png": 45210,
	"./contact_yt.png": 91206,
	"./dian.png": 35606,
	"./dian2.png": 52580,
	"./email/blank_logo.png": 53665,
	"./email/email_bg_icon.png": 45729,
	"./home/3_00.png": 58156,
	"./home/banner_card1.png": 97502,
	"./home/banner_card2.png": 34201,
	"./home/banner_card3.png": 8940,
	"./home/banner_card4.png": 87799,
	"./home/banner_card5.png": 44562,
	"./home/contact_banner.png": 77359,
	"./home/contact_banner_m.png": 14423,
	"./home/contact_bg.png": 69012,
	"./home/contact_bg2.png": 29402,
	"./home/contact_bg_m.png": 60488,
	"./home/digital-Layers1.png": 51138,
	"./home/digital-Layers2.png": 74957,
	"./home/digital-Layers3.png": 24992,
	"./home/digital-Layers4.png": 16243,
	"./home/digital-Layers5.png": 174,
	"./home/digital-game-bg-m.png": 86217,
	"./home/digital-game-bg.png": 77935,
	"./home/game_info_bg.png": 70339,
	"./home/home_footer_img.png": 35023,
	"./home/home_footer_img_m.png": 7479,
	"./home/hover_title.png": 97123,
	"./home/hover_title2.png": 63555,
	"./home/index_banner1.jpg": 14224,
	"./home/index_banner1.png": 98616,
	"./home/index_banner1_m.png": 46604,
	"./home/index_banner1_ms.png": 35943,
	"./home/index_banner2.png": 4191,
	"./home/index_banner2_m.png": 8871,
	"./home/index_banner3.png": 93818,
	"./home/index_banner3_m.png": 77210,
	"./home/index_banner4.png": 61793,
	"./home/index_banner4_m.png": 19613,
	"./home/index_banner5.png": 37012,
	"./home/index_banner5_m.png": 7016,
	"./home/index_banner_lavandula.png": 78674,
	"./home/index_banner_lavandula_m.png": 76498,
	"./home/news_arrow.png": 11829,
	"./home/news_banner.png": 84560,
	"./home/news_banner_m.png": 18628,
	"./home/sprite-min4.png": 99790,
	"./home/sprite-min5.png": 47891,
	"./log.png": 78356,
	"./log2.png": 1914,
	"./lunbo1.jpg": 86659,
	"./lunbo2.jpg": 92712,
	"./lunbo3.jpg": 15225,
	"./mail.png": 6387,
	"./mecha_snap/01.jpg": 22773,
	"./mecha_snap/02.jpg": 6662,
	"./mecha_snap/03.jpg": 85711,
	"./mecha_snap/04.jpg": 37920,
	"./mecha_snap/05.jpg": 92945,
	"./mecha_snap/06.jpg": 93954,
	"./mobile/adventure/adventure_banner.jpg": 29897,
	"./mobile/adventure/adventure_banner2.jpg": 98009,
	"./mobile/adventure/adventure_banner3.jpg": 14056,
	"./mobile/adventure/adventure_bg.jpg": 85770,
	"./mobile/adventure/adventure_bg02.jpg": 80520,
	"./mobile/adventure/adventure_bg03.jpg": 46361,
	"./mobile/adventure/adventure_bg04.jpg": 73550,
	"./mobile/adventure/adventure_bg05.jpg": 79447,
	"./mobile/adventure/adventure_title.png": 19155,
	"./mobile/adventure/adventure_title2.png": 86291,
	"./mobile/aiCard/banner1.jpg": 57297,
	"./mobile/aiCard/banner2.jpg": 21698,
	"./mobile/aiCard/banner3.jpg": 43803,
	"./mobile/aiCard/banner4.jpg": 44468,
	"./mobile/aiCard/banner5.jpg": 49365,
	"./mobile/aiCard/title_img.png": 41328,
	"./mobile/aiCard/title_img2.png": 57214,
	"./mobile/arrow1.png": 48515,
	"./mobile/arrow2.png": 22316,
	"./mobile/btn_gf.png": 39003,
	"./mobile/btn_readmore.png": 9187,
	"./mobile/close.png": 41361,
	"./mobile/confirm_bg.png": 10065,
	"./mobile/contact_banner.png": 12122,
	"./mobile/contact_bg.png": 44321,
	"./mobile/hans.png": 78387,
	"./mobile/logo2.png": 65832,
	"./mobile/luna.png": 17793,
	"./mobile/menu.png": 97106,
	"./mobile/partner_1.png": 25523,
	"./mobile/partner_2.png": 13660,
	"./mobile/partner_3.png": 29481,
	"./mobile/partner_4.png": 39778,
	"./mobile/partner_5.png": 38631,
	"./mobile/product_aigame.png": 62715,
	"./mobile/product_all.png": 90288,
	"./mobile/product_all2.png": 30142,
	"./mobile/product_board.png": 4781,
	"./mobile/product_board2.png": 25149,
	"./mobile/product_caif.png": 3066,
	"./mobile/product_conglin.png": 73585,
	"./mobile/product_elc.png": 54495,
	"./mobile/product_game.png": 14949,
	"./mobile/product_game2.png": 98213,
	"./mobile/product_witness.png": 31136,
	"./mobile/product_wod.png": 2555,
	"./mobile/product_xiyou.png": 23991,
	"./mobile/swiper1.jpg": 91388,
	"./mobile/swiper2.jpg": 54967,
	"./mobile/swiper3.jpg": 79278,
	"./mobile/swiper4.jpg": 9113,
	"./mobile/swiper5.jpg": 13320,
	"./mobile/swiper6.jpg": 9251,
	"./mobile/switch1.png": 45860,
	"./mobile/switch2.png": 67995,
	"./mobile/tailor/banner1.jpg": 40752,
	"./mobile/tailor/banner2.jpg": 81483,
	"./mobile/tailor/banner3.jpg": 6546,
	"./mobile/tailor/banner4.jpg": 52805,
	"./mobile/team_bg.png": 52294,
	"./mobile/westGame/banner1.jpg": 83314,
	"./mobile/westGame/banner2.jpg": 37057,
	"./mobile/westGame/banner3.jpg": 84304,
	"./mobile/westGame/banner4.jpg": 58239,
	"./mobile/white_logo.png": 7180,
	"./mobile/widerness/banner.png": 94662,
	"./mobile/widerness/bg.png": 96973,
	"./mobile/widerness/bg_Fragments1.png": 82624,
	"./mobile/widerness/bg_Fragments2.png": 23495,
	"./mobile/widerness/bg_Fragments3.png": 8770,
	"./mobile/widerness/bg_Fragments4.png": 38985,
	"./mobile/widerness/bg_Fragments5.png": 13692,
	"./mobile/widerness/big_title_img1.png": 10290,
	"./mobile/widerness/big_title_img2.png": 28509,
	"./mobile/widerness/big_title_img3.png": 84656,
	"./mobile/widerness/component_img1.png": 28110,
	"./mobile/widerness/component_img2.png": 92937,
	"./mobile/widerness/component_img3.png": 67644,
	"./mobile/widerness/game_num1.png": 11492,
	"./mobile/widerness/game_num2.png": 17275,
	"./mobile/widerness/more_bt_bg.png": 76990,
	"./mobile/widerness/paper_bg1.png": 74689,
	"./mobile/widerness/paper_bg2.png": 23974,
	"./mobile/widerness/paper_bg3.png": 87691,
	"./mobile/widerness/paper_clip.png": 26999,
	"./mobile/widerness/photo_preview/product10_preview.png": 4551,
	"./mobile/widerness/photo_preview/product1_preview.png": 51959,
	"./mobile/widerness/photo_preview/product2_preview.png": 75940,
	"./mobile/widerness/photo_preview/product3_preview.png": 5781,
	"./mobile/widerness/photo_preview/product4_preview.png": 70234,
	"./mobile/widerness/photo_preview/product5_preview.png": 44051,
	"./mobile/widerness/photo_preview/product6_preview.png": 98976,
	"./mobile/widerness/photo_preview/product7_preview.png": 10609,
	"./mobile/widerness/photo_preview/product8_preview.png": 88934,
	"./mobile/widerness/photo_preview/product9_preview.png": 94111,
	"./mobile/widerness/product1.png": 85630,
	"./mobile/widerness/product10.png": 39438,
	"./mobile/widerness/product2.png": 19641,
	"./mobile/widerness/product3.png": 20844,
	"./mobile/widerness/product4.png": 30231,
	"./mobile/widerness/product5.png": 50226,
	"./mobile/widerness/product6.png": 58141,
	"./mobile/widerness/product7.png": 208,
	"./mobile/widerness/product8.png": 54763,
	"./mobile/widerness/product9.png": 97574,
	"./mobile/widerness/product_cover1.png": 71174,
	"./mobile/widerness/product_cover2.png": 11297,
	"./mobile/widerness/text_bg.png": 73773,
	"./mobile/widerness/three_icon1.png": 61245,
	"./mobile/widerness/three_icon2.png": 26674,
	"./mobile/widerness/three_icon3.png": 86263,
	"./mobile/winner_banner.jpg": 69767,
	"./mobile/winner_bg.jpg": 40032,
	"./mobile/winner_bg2.jpg": 3817,
	"./mobile/winner_title.png": 82133,
	"./mobile/winner_title2.png": 46997,
	"./mobile/winner_video_bg.png": 11812,
	"./nav_bg.png": 85709,
	"./news_bg.png": 72239,
	"./news_bg_left_01.png": 55757,
	"./news_bg_left_02.png": 17282,
	"./news_bg_right.png": 95144,
	"./news_corner_left.png": 44159,
	"./news_corner_right.png": 73974,
	"./pc/adventure/adventure_banner.jpg": 11845,
	"./pc/adventure/adventure_banner2.jpg": 91256,
	"./pc/adventure/adventure_banner3.jpg": 46025,
	"./pc/adventure/adventure_bg.jpg": 66277,
	"./pc/adventure/adventure_bg02.jpg": 49380,
	"./pc/adventure/adventure_bg03.jpg": 51310,
	"./pc/adventure/adventure_bg04.jpg": 36569,
	"./pc/adventure/adventure_bg05.jpg": 30408,
	"./pc/adventure/adventure_title.png": 66734,
	"./pc/adventure/adventure_title2.png": 53900,
	"./pc/aiCard/banner1.jpg": 51758,
	"./pc/aiCard/banner2.jpg": 90557,
	"./pc/aiCard/banner3.jpg": 47516,
	"./pc/aiCard/bg.jpg": 24118,
	"./pc/aiCard/title_img.png": 32263,
	"./pc/aiCard/title_img2.png": 69967,
	"./pc/btn_gf.png": 68264,
	"./pc/btn_readmore.png": 45388,
	"./pc/confirm_bg.png": 13442,
	"./pc/contact_banner.png": 7485,
	"./pc/contact_bg.png": 25538,
	"./pc/email_bg_icon.png": 57030,
	"./pc/hans.png": 11024,
	"./pc/logo2.png": 35081,
	"./pc/luna.png": 7746,
	"./pc/new4.jpg": 53026,
	"./pc/news1.png": 55150,
	"./pc/news2.png": 43977,
	"./pc/news3.png": 75260,
	"./pc/news4.png": 16359,
	"./pc/partner_1.png": 28674,
	"./pc/partner_2.png": 52493,
	"./pc/partner_3.png": 2528,
	"./pc/partner_4.png": 93779,
	"./pc/partner_5.png": 77710,
	"./pc/partner_arrowl.png": 82612,
	"./pc/partner_arrowr.png": 20770,
	"./pc/product_aigame.png": 49772,
	"./pc/product_all.png": 73909,
	"./pc/product_all2.png": 73013,
	"./pc/product_board.png": 78364,
	"./pc/product_board2.png": 23506,
	"./pc/product_caif.png": 51389,
	"./pc/product_conglin.png": 61112,
	"./pc/product_game.png": 67498,
	"./pc/product_game2.png": 92944,
	"./pc/product_game_banner.png": 63171,
	"./pc/product_witness.png": 35989,
	"./pc/product_wod.png": 33254,
	"./pc/product_xiyou.png": 21614,
	"./pc/swiper1.jpg": 19397,
	"./pc/swiper2.jpg": 17782,
	"./pc/swiper3.jpg": 56159,
	"./pc/swiper4.jpg": 9168,
	"./pc/swiper5.jpg": 4353,
	"./pc/swiper6.jpg": 52754,
	"./pc/swiper_img1.png": 18357,
	"./pc/swiper_img2.png": 99498,
	"./pc/tailor/banner.jpg": 44162,
	"./pc/tailor/banner2.jpg": 63720,
	"./pc/tailor/banner3.jpg": 29561,
	"./pc/tailor/banner4.jpg": 40398,
	"./pc/team_bg.png": 6507,
	"./pc/thr2.png": 15180,
	"./pc/westGame/banner1.jpg": 71809,
	"./pc/westGame/banner2.jpg": 18066,
	"./pc/westGame/banner3.jpg": 98603,
	"./pc/westGame/banner4.jpg": 40164,
	"./pc/white_logo.png": 31347,
	"./pc/widerness/banner.jpg": 57009,
	"./pc/widerness/banner_next.png": 12939,
	"./pc/widerness/banner_prev.png": 75179,
	"./pc/widerness/bg.png": 16634,
	"./pc/widerness/bg_fragments1.png": 36725,
	"./pc/widerness/bg_fragments2.png": 83722,
	"./pc/widerness/bg_fragments3.png": 29071,
	"./pc/widerness/bg_fragments4.png": 82628,
	"./pc/widerness/bg_fragments5.png": 13681,
	"./pc/widerness/bg_fragments6.png": 85622,
	"./pc/widerness/bg_fragments7.png": 4763,
	"./pc/widerness/big_title_img1.png": 81501,
	"./pc/widerness/big_title_img2.png": 73586,
	"./pc/widerness/big_title_img3.png": 53591,
	"./pc/widerness/component_img1.png": 47481,
	"./pc/widerness/component_img2.png": 80702,
	"./pc/widerness/component_img3.png": 32067,
	"./pc/widerness/game_num1.png": 98929,
	"./pc/widerness/game_num2.png": 13302,
	"./pc/widerness/more_bt_bg.png": 84041,
	"./pc/widerness/more_img1.png": 1985,
	"./pc/widerness/more_img2.png": 61862,
	"./pc/widerness/pagination.png": 56871,
	"./pc/widerness/pagination_active.png": 61480,
	"./pc/widerness/paper_bg1.png": 44596,
	"./pc/widerness/paper_bg2.jpg": 16255,
	"./pc/widerness/paper_bg3.png": 15014,
	"./pc/widerness/paper_clip.png": 41828,
	"./pc/widerness/photo_preview/product10_preview.png": 85690,
	"./pc/widerness/photo_preview/product1_preview.png": 31632,
	"./pc/widerness/photo_preview/product2_preview.png": 61987,
	"./pc/widerness/photo_preview/product3_preview.png": 77738,
	"./pc/widerness/photo_preview/product4_preview.png": 32261,
	"./pc/widerness/photo_preview/product5_preview.png": 11284,
	"./pc/widerness/photo_preview/product6_preview.png": 83335,
	"./pc/widerness/photo_preview/product7_preview.png": 1966,
	"./pc/widerness/photo_preview/product8_preview.png": 75273,
	"./pc/widerness/photo_preview/product9_preview.png": 32024,
	"./pc/widerness/product1.png": 36233,
	"./pc/widerness/product10.png": 4827,
	"./pc/widerness/product2.png": 32910,
	"./pc/widerness/product3.png": 48627,
	"./pc/widerness/product4.png": 3008,
	"./pc/widerness/product4_preview.png": 84097,
	"./pc/widerness/product5.png": 62829,
	"./pc/widerness/product6.png": 62882,
	"./pc/widerness/product7.png": 61735,
	"./pc/widerness/product8.png": 43332,
	"./pc/widerness/product9.png": 58033,
	"./pc/widerness/product_cover1.png": 20181,
	"./pc/widerness/product_cover2.png": 67178,
	"./pc/widerness/text_bg.png": 98576,
	"./pc/widerness/three_icon.png": 98215,
	"./pc/widerness/video_bg.png": 66362,
	"./pc/winner_banner.jpg": 27290,
	"./pc/winner_bg.jpg": 86669,
	"./pc/winner_bg2.jpg": 46197,
	"./pc/winner_title.png": 35302,
	"./pc/winner_title2.png": 30644,
	"./pc/winner_title3.png": 71777,
	"./pc/winner_video_bg.png": 95937,
	"./product/back_icon.png": 55857,
	"./product/bga.png": 7048,
	"./product/close-icon.png": 39108,
	"./product/close-red.png": 27644,
	"./product/close.png": 6006,
	"./product/comingSoon.png": 93130,
	"./product/comment-icon.png": 88541,
	"./product/creator-arrow.png": 91038,
	"./product/mobile/bga.png": 57471,
	"./product/mobile/close-icon.png": 59845,
	"./product/mobile/comingSoon.png": 92403,
	"./product/mobile/comment-icon.png": 21080,
	"./product/mobile/creator-arrow.png": 41461,
	"./product/mobile/pay-type1.png": 1137,
	"./product/mobile/pay-type2.png": 73078,
	"./product/mobile/pay-type3.png": 92219,
	"./product/mobile/shop_car.png": 77220,
	"./product/mobile/soldOut.png": 75191,
	"./product/mobile/star-active.png": 89966,
	"./product/mobile/star.png": 64423,
	"./product/more_img2.png": 46301,
	"./product/pause-icon.png": 7194,
	"./product/pay-type1.png": 45194,
	"./product/pay-type2.png": 98197,
	"./product/pay-type3.png": 56840,
	"./product/product_banner.png": 67520,
	"./product/product_bg1.png": 49216,
	"./product/product_bg2.png": 6439,
	"./product/product_bg3.png": 75362,
	"./product/shop_car.png": 95201,
	"./product/shop_car2.png": 74937,
	"./product/sku-pay-img.png": 70942,
	"./product/soldOut.png": 89512,
	"./product/star-active.png": 61941,
	"./product/star.png": 2658,
	"./product1.png": 32076,
	"./product2.png": 70467,
	"./product3.png": 84414,
	"./product4.png": 28701,
	"./product_bg.png": 44423,
	"./product_logo.png": 75099,
	"./products.png": 2110,
	"./tag-hot.png": 2928,
	"./tag-new.png": 95147,
	"./team.png": 4853,
	"./team/team_Img.png": 14199,
	"./team/team_banner.png": 12676,
	"./team/team_banner_m.png": 32664,
	"./team/team_logo.png": 96975,
	"./team_avatar1.png": 15712,
	"./team_avatar2.png": 56583,
	"./team_bg.png": 57905
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 27344;